<script lang="ts">import { formatDateFromUtcToLocale, isFuture } from "../../utils";
import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { cleanStringTranslation, isSpecialWidthCase } from "@infinitro/global";
import { Text } from "@infinitro/text";
import ActionButton from "./action-button.svelte";
export let isDetail = false;
export let promo;
export let isBigScreen = false;
export let active = false;
$: useAlternative2 = $stateUi.promotions.promotionsStyle === "alternative2";
$: useMomentum = $stateUi.promotions.promotionsStyle === "momentum";
</script>

<div
	class="promo-info-container {isDetail && 'promo-info-container-detail'}"
	class:promo-info-container-alternative-2={useAlternative2}
	class:promo-info-container-momentum={useMomentum}
>
	<div class="promo-info {isDetail && 'promo-info-detail'}">
		<div
			class="text-container"
			class:text-container-center={!(promo.startDate && isFuture(promo.startDate)) || promo.endDate}
		>
			{#if isDetail}
				<Text type="title" titleSize="h4" titleWeight={useAlternative2 ? 'regular' : 'bold'}>
					{$t(promo.footerText || promo.title)}
				</Text>
			{:else}
				<div class="promotion-title-container">
					<p
						class:promotion-title-text={!$isSpecialWidthCase}
						class:promotion-title-text-special={$isSpecialWidthCase}
						class:promotion-title-text-alternative-2={useAlternative2}
						class:promotion-title-text-momentum={useMomentum}
					>
						{cleanStringTranslation($t(promo.footerText || promo.title))}
					</p>
				</div>
			{/if}
			{#if (promo.startDate && isFuture(promo.startDate)) || promo.endDate}
				<div class="promo-info-date {isDetail && 'promo-info-detail-date'}">
					{#if promo.startDate && isFuture(promo.startDate)}
						<span class="d-flex">
							<Text
								type="body"
								textColor="gray"
								bodyWeight="light"
								customStyle={`${isBigScreen ? 'font-size: 0.7rem !important;' : 'font-size: 11px !important;'}`}
							>
								{$t(Verbiage.starts)}:
							</Text>
							<Text
								type="body"
								bodyWeight="regular"
								customStyle={`${isBigScreen ? 'font-size: 0.7rem !important;' : 'font-size: 11px !important;'}`}
							>
								{formatDateFromUtcToLocale(promo.startDate)}
							</Text>
						</span>
					{/if}
					{#if promo.endDate}
						<span class="d-flex">
							<Text
								type="body"
								textColor="gray"
								bodyWeight="light"
								customStyle={`${isBigScreen ? 'font-size: 0.7rem !important;' : 'font-size: 11px !important;'}`}
							>
								{isFuture(promo.endDate) ? $t(Verbiage.finishes) : $t(Verbiage.ended)}:
							</Text>
							<Text
								type="body"
								bodyWeight="regular"
								customStyle={`${isBigScreen ? 'font-size: 0.7rem !important;' : 'font-size: 11px !important;'}`}
							>
								{formatDateFromUtcToLocale(promo.endDate)}
							</Text>
						</span>
					{/if}
				</div>
			{/if}
		</div>
		<ActionButton {promo} {isDetail} {active} />
	</div>
</div>

<style>
	.text-container {
		display: flex;
		height: 100%;
		width: 100%;
		flex-direction: column;
		justify-content: space-between;
		padding-top: 0.5rem;
		padding-bottom: 0.5rem;
		max-width: calc(100% - 125px)
}

	.text-container-center {
		justify-content: center
}

	.promotion-title-container {
		width: 100%
}
	.promotion-title-text {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 16px;
		font-weight: 600
}
	.promotion-title-text-special {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 14px
}

	@media (min-width: 640px) {
		.promotion-title-text {
				font-size: 18px
		}
	}

	.promotion-title-text-alternative-2 {
		font-size: 16px;
		font-weight: 400
}

	.promotion-title-text-momentum {
		font-size: 16px;
		font-weight: 400;
		text-transform: uppercase;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

	.promo-info-container {
		display: flex;
		height: 78px;
		width: 100%;
		flex-direction: column;
		row-gap: 0.25rem;
		padding-top: 0.125rem;
		padding-bottom: 0.125rem
}

	.promo-info-container-alternative-2 {
		height: 86px;
		background: linear-gradient(to right, var(--color-tertiary-300), var(--color-background-500))
}

	.promo-info-container-momentum {
		border-bottom-right-radius: 0.5rem;
		border-bottom-left-radius: 0.5rem;
		background-color: var(--color-background-500)
}

	.promo-info {
		display: flex;
		height: 100%;
		width: 100%;
		justify-content: space-between;
		padding-left: 0.375rem;
		padding-right: 0.375rem
}

	@media (min-width: 1024px) {
		.promo-info {
				padding-left: 0.75rem;
				padding-right: 0.75rem
		}
	}

	.promo-info-detail {
		justify-content: center
}

	.promo-info-date {
		display: flex;
		width: 100%;
		flex-direction: row;
		gap: 0.5rem
}
	.promo-info-detail-date {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		gap: 2rem
}

	.icon {
		margin-bottom: 2px;
		height: 0.75rem;
		width: 0.75rem
}
	.d-flex {
		margin-bottom: 0.5rem;
		margin-top: 0.25rem;
		display: flex;
		align-items: center;
		gap: 0.25rem
}
</style>
